import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ICON } from "../../constants";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Helmet } from "react-helmet";
import commonStyles from "../commonStyles";
import CustomPopup from "../Common/CustomPopup";
import SiteDrawer from "../Common/siteDrawer";
import DrawerHeader from "../Common/DrawerHeader";
import useStyles from "./styles";
import clsx from "clsx";
import { getSvgIcon } from "../../svgUtility";
import ReviewCard from "./ReviewCard";

function WebListVenuePage() {
  const comClasses = commonStyles();
  const classes = useStyles();

  const isMobileDevice = window.navigator.userAgent
    .toLowerCase()
    .includes("mobi");

  const [dialogOpen, setDialogOpen] = useState(false);

  const onClose = (open) => () => {
    setDialogOpen(open);
  };

  const scriptURL =
    "https://script.google.com/macros/s/AKfycbw6r2vAaaJjEv8zMiyR5veV4HTc7vb8iPSX3QBZlJJo8P946hhuGx8VpUTYUUxejHTT/exec";
  const form = document.forms["google-sheet"];

  const faqs = [
    {
      ques: "Q: How long does the onboarding take?",
      ans: "A: We can get your venue listed and live on the platform the same day you sign up. Our sports venue booking platform makes onboarding quick and hassle-free.",
    },
    {
      ques: "Q: Is there any listing fee?",
      ans: "A: No, there’s absolutely no listing fee. You can register your venue and start receiving bookings without any upfront cost.",
    },
    {
      ques: "Q: Can I manage bookings through an app?",
      ans: "A: Yes, you’ll get access to the KheloMore Partner App, which lets you manage your slots, track bookings, view reports, and stay updated in real-time.",
    },
    {
      ques: "Q: How do I receive payments?",
      ans: "A: Payouts are processed on a weekly basis, along with detailed reports for full transparency.",
    },
    {
      ques: "Q: What if I don’t have someone tech-savvy to manage the platform?",
      ans: "A: No problem — the app is as easy as using WhatsApp. Our team is always ready to assist or manage it for you.",
    },
    {
      ques: "Q: What if I only want to take offline bookings?",
      ans: "A: You can do that too. Use the app to manage both online and walk-in customers seamlessly.",
    },
    {
      ques: "Q: What’s the catch?",
      ans: "A: There isn’t one. No hidden costs, no surprise fees.",
    },
  ];

  const shadowCardData = [
    {
      heading: "Increase Visibility Online",
      para: "Rank higher on Google with built-in SEO from your KheloMore sports venue booking platform.",
    },
    {
      heading: "Reach 10L+ Sports Enthusiasts",
      para: "Get discovered by players actively booking in your area.",
    },
    {
      heading: "Manage Bookings with Ease",
      para: "Our sports venue management software lets you accept bookings online or offline, track slots, and get confirmations on WhatsApp.",
    },
    {
      heading: "Get Marketing Support",
      para: "Run promotions, offers, and event invites via our in-app promotions panel.",
    },
    {
      heading: "Dedicated Partner Success Team",
      para: "Setup in under 15 mins, with onboarding & support every step of the way",
    },
  ];

  const features = [
    {
      title: "Calendar & List View",
      description:
        "Quickly book or block slots. See availability and bookings at a glance",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-scale-1.png",
    },
    {
      title: "WhatsApp/SMS Confirmations",
      description: "Get instant alerts for bookings, cancellations & changes",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-sacle-2.png",
    },
    {
      title: "Bulk Booking & Payment Tools",
      description: "Book or block in bulk and send payment links conveniently",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-scale-3.png",
    },
    {
      title: "Flexible Booking Edits",
      description: "Add extra time, charges, or services to ongoing bookings",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-scale-4.png",
    },
    {
      title: "Customer Info & Reports",
      description:
        "Track income, slot occupancy, and popular timings, increasing user retention and loyalty",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-sacle-5.png",
    },
    {
      title: "Super Convenient User App",
      description:
        "Reschedule or Cancel with Ease - Venues stay in Control of their rules",
      image:
        "https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-list-venue-sacle-6.png",
    },
  ];

  const [registerDrawer, setRegisterDrawer] = useState(false);
  const [userName, setUserName] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();
  const [sports, setSports] = useState();
  const [venueName, setVenueName] = useState();
  const [otherInfo, setOtherInfo] = useState();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState();
  const [firstTwoFaqs, setFirstTwoFaqs] = useState();

  const [isSeeAll, setIsSeeAll] = useState(false);
  const bottomRef = useRef(null);
  const formRef = useRef(null);

  // useEffect(() => {
  //   const link = document.createElement("link");
  //   link.href =
  //     "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap";
  //   link.rel = "stylesheet";
  //   document.head.appendChild(link);
  // }, []);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (isSeeAll) {
      if (bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
    const filteredFaqData = faqs?.slice(0, 2);
    setFirstTwoFaqs(filteredFaqData);
  }, [isSeeAll]);

  const handleChange = (event) => {
    let key = event.target.name;
    let value = event.target.value;
    switch (key) {
      case "name":
        setUserName(value);
        break;
      case "mobileNumber":
        setPhone(value);
        break;
      case "venueLocation":
        setAddress(value);
        break;
      case "venueSports":
        setSports(value);
        break;

      case "venueName":
        setVenueName(value);
        break;

      case "Any other information share":
        setOtherInfo(value);
        break;

      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    window.fbq("track", "Subscribe", {
      name: userName,
      mobileNumber: phone,
    });

    if (
      userName?.length ||
      phone?.length ||
      address?.length ||
      sports?.length ||
      venueName?.length
    ) {
      let formData = new FormData(form);
      formData.append("dateTime", new Date()?.toLocaleString());
      fetch(scriptURL, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      })
        .then((response) => {
          setConfirmDialogOpen(true);
        })
        .catch((error) => console.error("Error!", error.message));
    }
    setRegisterDrawer(false);
    setUserName("");
    setPhone("");
    setAddress("");
    setSports("");
    setVenueName("");
    setOtherInfo("");
  };

  const clearData = () => {
    if (registerDrawer) {
      setUserName("");
      setPhone("");
      setAddress("");
      setSports("");
      setVenueName("");
      setOtherInfo("");
    }
  };

  const handleConfirmBackClose = (event, action) => {
    if (event) event.preventDefault();
    setConfirmDialogOpen(false);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>List Your Sports Venue Online | KheloMore Venue Partner</title>
        <link rel="canonical" href={window.location.href} />
        <meta
          name="description"
          content="Register your sports venue on KheloMore. Boost online visibility, manage bookings with ease, and reach 10L+ players across 80+ cities. Start today for free!"
        />
        <meta
          name="keywords"
          content="Register your sports venue on KheloMore, Register your sports venue, Sports venue on KheloMore, Book sports turf online, List your sports venue"
        />
        <meta
          property="og:title"
          content="List Your Sports Venue Online | KheloMore Venue Partner"
        />
        <meta
          property="og:description"
          content="Register your sports venue on KheloMore. Boost online visibility, manage bookings with ease, and reach 10L+ players across 80+ cities. Start today for free!"
        />
        <meta property="og:url" content={window.location.href} />
        ----------------OGCard Section -------------------------
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="En" />
      </Helmet>
      <div className={classes.mainContainer}>
        <header
          className={clsx(
            classes.flex,
            classes.spaceBw,
            classes.alignCenter,
            comClasses.relative,
            classes.downShadow,
          )}
        >
          <div>
            <Link to="/">
              <img
                className={classes.kmImage}
                src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/km-com-new-logo.png"
                alt="khelomore"
              />
            </Link>
          </div>
          <div
            className={clsx(
              classes.flex,
              classes.justifyCenter,
              classes.alignCenter,
            )}
          >
            <button
              onClick={scrollToForm}
              className={clsx(
                classes.ctaTwo,
                classes.flex,
                classes.justifyCenter,
                classes.alignCenter,
              )}
            >
              Register your venue
            </button>
          </div>
        </header>
        <main className={clsx(comClasses.mtb48lr120)}>
          <div>
            <img
              className={clsx(classes.w100, comClasses.br16)}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/web-list-sports-venue-hero.jpg"
              alt="list your sports venue"
            />
          </div>
          <div className={clsx(comClasses.mT32)}>
            <h1 className={clsx(classes.topHeading)}>
              List Your Sports Venue - Join India's Leading Sports Venue Listing
              Platform
            </h1>
            <p
              className={clsx(
                classes.faqHead,
                classes.faqPara,
                comClasses.mT16,
              )}
            >
              Transform your sports facility into a thriving business with
              KheloMore's comprehensive sports venue management software.
              Register your sports venue today and connect with thousands of
              sports enthusiasts looking for quality facilities across India.
            </p>
            <h4 className={clsx(classes.acrossCity, comClasses.mB16)}>
              Key Benefits:
            </h4>
            <ul>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Maximize Revenue: Increase bookings by up to 300% with our
                intelligent listing system
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Streamlined Management: Complete venue management tools in one
                platform
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Instant Visibility: Get discovered by local sports communities
                immediately
              </li>
              {/* <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle
                )}
              >
                Zero Commission: Keep 100% of your booking revenue
              </li> */}
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Marketing Automation: Smart Notifications to remind slot drop
                off users and regain lost users of your venue
              </li>
            </ul>
          </div>
          <div className={clsx(classes.hrLine, comClasses.mT32)}></div>
          <div
            className={clsx(
              classes.flex,
              classes.justifyCenter,
              classes.alignCenter,
              comClasses.mTB12,
            )}
          >
            <h4 className={classes.acrossCity}>Across 180 + Cities</h4>
            <span className={classes.verLine}></span>
            <h4 className={classes.acrossCity}>Trusted by 2500 + Venues</h4>
          </div>

          <div className={classes.hrLine}></div>

          <div
            className={clsx(
              classes.flex,
              comClasses.alignCenter,
              comClasses.mT32,
            )}
          >
            <button onClick={scrollToForm} className={clsx(classes.ctaTwo)}>
              Register your venue
            </button>
          </div>

          <div className={clsx(comClasses.mT32)}>
            <h2 className={clsx(classes.topHeading)}>
              Why Choose KheloMore's Sports Venue Listing Platform?
            </h2>
            <p
              className={clsx(
                classes.faqHead,
                classes.faqPara,
                comClasses.mT16,
              )}
            >
              KheloMore stands as the premier sports venue listing software
              designed specifically for Indian sports facility owners. Our
              platform combines advanced booking technology with local market
              expertise to help you maximize your venue's potential.​
            </p>
            <h4 className={clsx(classes.acrossCity, comClasses.mB16)}>
              Platform Advantages:
            </h4>
            <ul>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Real-time Booking System: Automated slot management and instant
                confirmations
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Multi-sport Support: Cricket, football, badminton, tennis,
                basketball, and more
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Mobile-first Design: 85% of bookings happen on mobile devices
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                Local Payment Integration: UPI, net banking, and digital wallet
                support
              </li>
              <li
                className={clsx(
                  classes.faqHead,
                  classes.faqPara,
                  classes.listStyle,
                )}
              >
                24/7 Customer Support: Dedicated support team for venue owners
              </li>
            </ul>
          </div>

          <div className={clsx(comClasses.mT32)}>
            <h2 className={classes.topHeading}>Why Venue Partners Trust Us?</h2>
            <div className={classes.flexContainer}>
              <div className={classes.topRow}>
                {shadowCardData.slice(0, 3).map((card, index) => (
                  <div key={index} className={classes.card}>
                    <h3 className={classes.cardHeading}>{card.heading}</h3>
                    <p className={classes.cardPara}>{card.para}</p>
                  </div>
                ))}
              </div>

              <div className={classes.bottomRow}>
                {shadowCardData.slice(3, 5).map((card, index) => (
                  <div key={index + 3} className={classes.card}>
                    <h3 className={classes.cardHeading}>{card.heading}</h3>
                    <p className={classes.cardPara}>{card.para}</p>
                  </div>
                ))}
              </div>
            </div>

            <div
              className={clsx(
                classes.flex,
                classes.alignCenter,
                comClasses.mT32,
                classes.justifyCenter,
              )}
            >
              <button onClick={scrollToForm} className={clsx(classes.ctaTwo)}>
                Become a venue partner
              </button>
            </div>
          </div>
          <div className={clsx(classes.hrLine, comClasses.mT32)}></div>
          <div>
            <h2
              className={clsx(
                classes.topHeading,
                classes.textCenter,
                comClasses.mT64,
                comClasses.mB60,
              )}
            >
              Built for Venue Owners Who Want Simplicity + Scale — from
              registering sports venue online to growing bookings seamlessly.
            </h2>
            {/* gcode */}
            <div className={classes.featureContainer}>
              {features.map((item, index) => (
                <div
                  key={index}
                  className={clsx(classes.featureRow, {
                    [classes.reverse]: index % 2 === 1,
                  })}
                >
                  <div className={classes.featureImage}>
                    <img src={item.image} alt={item.title} />
                  </div>
                  <div
                    className={clsx(
                      classes.featureText,
                      index % 2 === 0
                        ? classes.textLeftOffset
                        : classes.textRightOffset,
                    )}
                  >
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* g code end */}
          </div>
          <div className={classes.hrLine}></div>
          {/* caraousel */}
          <div>
            <h2
              className={clsx(
                classes.topHeading,
                comClasses.mT64,
                comClasses.mB32,
              )}
            >
              Real Impact You Can See
            </h2>
          </div>
          <ReviewCard />

          <div ref={formRef} className={comClasses.mT64}>
            <div>
              <h2 className={clsx(classes.topHeading, classes.mB10)}>
                Join Thousands of Successful Venue Owners
              </h2>
              <p className={clsx(classes.talkText, classes.cardPara)}>
                Ready to transform your sports facility with India's leading
                sports venue listing platform? Start your journey with KheloMore
                and unlock your venue's full potential.
              </p>
            </div>
            {/* <div
              className={clsx(
                classes.flex,
                classes.alignCenter,
                comClasses.mT32
              )}
            >
              <button
                className={clsx(classes.ctaTwo)}
              >
                Register your venue
              </button>
            </div> */}
          </div>
          <div className={clsx(comClasses.mT64, classes.formContainer)}>
            <div className={comClasses.mB32}>
              <h2 className={clsx(classes.topHeading, classes.mB10)}>
                Let’s Talk.
              </h2>
              <p className={clsx(classes.talkText, classes.cardPara)}>
                We’ll walk you through setup, onboarding, and everything after.
              </p>
            </div>
            <div>
              <form
                onSubmit={handleSubmit}
                autocomplete="off"
                name="google-sheet"
              >
                <div className={classes.formGrid}>
                  <input
                    type="text"
                    value={userName}
                    name="name"
                    onChange={handleChange}
                    placeholder="Your Name *"
                    className={classes.participantInput}
                  />
                  <input
                    type="number"
                    value={phone}
                    name="mobileNumber"
                    onChange={handleChange}
                    placeholder="Contact Number *"
                    className={clsx(classes.participantInput)}
                  />
                  <input
                    type="text"
                    value={venueName}
                    name="venueName"
                    onChange={handleChange}
                    placeholder="Venue Name *"
                    className={clsx(classes.participantInput)}
                  />
                  <input
                    type="text"
                    value={address}
                    name="venueLocation"
                    onChange={handleChange}
                    placeholder="Venue City & Location *"
                    className={clsx(classes.participantInput)}
                  />
                  <input
                    type="text"
                    value={sports}
                    name="venueSports"
                    onChange={handleChange}
                    placeholder="Sports Available At Venue *"
                    className={clsx(classes.participantInput)}
                  />
                  <textarea
                    value={otherInfo}
                    name="Any other information share"
                    onChange={handleChange}
                    placeholder="Any other information you want to share"
                    className={clsx(classes.participantInput)}
                    rows={8}
                  />
                </div>

                <div className={clsx(classes.finalBox2, comClasses.mT32)}>
                  <div className={clsx(classes.finalBtn2)}>
                    {userName && phone && address && sports && venueName ? (
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        className={clsx(classes.finalButton2, classes.orangeBg)}
                      >
                        SUBMIT
                      </button>
                    ) : (
                      <button
                        disabled
                        className={clsx(classes.finalButton2, classes.disabled)}
                      >
                        SUBMIT
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* <div className={clsx(classes.hrLine, comClasses.mT32)}></div> */}
          {/* faq section */}
          <div className={clsx(classes.faqDetail)}>
            <div className={comClasses.mB32}>
              <span className={clsx(classes.topHeading, comClasses.mT64)}>
                FAQs
              </span>
              <div className={clsx(classes.faqLine, classes.hrLine)}></div>
            </div>
            {isSeeAll
              ? faqs?.map((faqs, idx) => {
                  return (
                    <div key={idx}>
                      <h6 className={classes.faqHead}>{faqs?.ques}</h6>
                      <p className={clsx(classes.faqHead, classes.faqPara)}>
                        {faqs?.ans}
                      </p>
                    </div>
                  );
                })
              : firstTwoFaqs?.map((data, idx) => {
                  return (
                    <div key={idx}>
                      <h6 className={classes.faqHead}>{data?.ques}</h6>
                      <p className={clsx(classes.faqHead, classes.faqPara)}>
                        {data?.ans}
                      </p>
                    </div>
                  );
                })}
            {isSeeAll && <div ref={bottomRef} />}

            <div
              className={clsx(classes.hrLine, comClasses.mT32, comClasses.mB32)}
            ></div>
            <div
              className={clsx(
                classes.flex,
                classes.justifyCenter,
                comClasses.relative,
              )}
            >
              <span className={classes.circle}>
                {isSeeAll ? (
                  <span
                    className={clsx(classes.seeAll, classes.rotate)}
                    onClick={() => {
                      setIsSeeAll(false);
                    }}
                  >
                    {getSvgIcon(ICON.DOWN_ARROW_ICON)}
                  </span>
                ) : (
                  <span
                    className={classes.seeAll}
                    onClick={() => {
                      setIsSeeAll(true);
                    }}
                  >
                    {getSvgIcon(ICON.DOWN_ARROW_ICON)}
                  </span>
                )}
              </span>
            </div>
          </div>
          {/* {registerDrawer ? (
            <SiteDrawer
              className={classes.customDrawerContent}
              drawerType="bottom"
              isDrawerOpen={registerDrawer}
              drawerCloseHandler={setRegisterDrawer}
              isBottomDrawer={true}
              isCustomDrawer={true}
              drawerWrapperClass={classes.drawerAutoHeight2}
              drawerBodyClass={classes.drawerBodyHeight2}
            >
              <DrawerHeader
                heading="List Your Sports Venue"
                drawerOpen={registerDrawer}
                setDrawerOpen={setRegisterDrawer}
                clearData={clearData}
              /> */}

          {/* </SiteDrawer>
          ) : (
            ""
          )} */}
          <CustomPopup
            // doneIcon={classes.doneIcon}
            topText={classes.topTextTwo}
            open={confirmDialogOpen}
            action1={handleConfirmBackClose}
            action2={() => setConfirmDialogOpen(false)}
            heading="Thank you, record received"
            btnText2="Close"
            icon={getSvgIcon(ICON.DONE_ICON)}
          />
        </main>
      </div>
    </>
  );
}
export default WebListVenuePage;
